import {
  IField,
  IFieldTag,
  IFormDocument,
} from 'app/services/api5-service/api.interface';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { ISPFormState } from 'common/dynamic-form/model';

import { FieldTag } from './model';

/**
 * Get tag FE data from BE
 *
 * @param field
 * @param doc
 */
function getFieldTag(field: IField, doc: IFormDocument): FieldTag | undefined {
  if (!field.tag || !doc[field.tag.$name]) {
    return undefined;
  }

  const tagName = field.tag.$name;
  const dataForTag: IFieldTag = doc[tagName];

  const tag: FieldTag = {
    name: tagName,
    color: dataForTag.color?.$,
    text: dataForTag.text?.$,
    hintText: dataForTag.hint?.$,
  };

  const price = dataForTag.price;
  if (price) {
    tag.price = {
      currency: price.currency?.$,
      oldCost: price.no_discount_cost?.$,
      percent: price.percent?.$,
    };
  }

  return tag;
}

/**
 * Get stream of tag data for field
 *
 * @param field
 * @param state
 */
export function getFieldTag$(
  field: IField,
  state: ISPFormState,
): Observable<FieldTag | undefined> {
  return state.docSubject.pipe(
    map(doc => getFieldTag(field, doc)),
    shareReplay({
      refCount: true,
      bufferSize: 1,
    }),
  );
}
